import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { PageLoader } from "./ui/page-loader";

function RequireAuth() {
  const { auth, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while auth is being loaded from localStorage
  if (isLoading) {
    return <PageLoader fullScreen />;
  }

  // If not authenticated, check for wizard data to determine redirect destination
  if (!auth?.email) {
    // Check if user is coming from marketing site wizard flow
    const hasWizardData = sessionStorage.getItem('clary_wizard_prefill');

    if (hasWizardData) {
      // User has wizard data - redirect to signup (better UX for new users from marketing)
      // Redirect back to /portal after auth (where My Activities/wizard lives)
      const returnPath = encodeURIComponent('/portal');
      return (
        <Navigate
          to={`/signup?return=${returnPath}&from_wizard=true`}
          state={{ from: location }}
          replace
        />
      );
    }

    // Regular auth flow - redirect to login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export default RequireAuth;
